import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { fetchProjects } from '../services/ProjectService';

type Project = {
    id: string;
    name: string;
    data: any;
};

const UserProjects: React.FC = () => {
    const { token } = useAuth();
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserProjects = async () => {
            if (!token) return;
            try {
                const userProjects = await fetchProjects(token);
                setProjects(userProjects);
            } catch (error) {
                console.error('Failed to fetch projects:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserProjects();
    }, [token]);

    if (loading) return <div>Loading projects...</div>;

    return (
        <div>
            <h2>Your Projects</h2>
            {projects.length === 0 ? (
                <p>No projects found.</p>
            ) : (
                <ul>
                    {projects.map((project) => (
                        <li key={project.id}>{project.name}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default UserProjects;
